import React from 'react'
import stackData from './stackData'
import "./Stack.scss"

export default function Stack() {

  return (
    <div className="stack" id="stack">
        <h1>Technologies</h1>
        <div className="container">
          {stackData.map((d) => (
            <div className="img-container">
              <img src={d.logo} alt={d.name} title={d.name}/>
            </div>
          ))}
          
        </div>
    </div>

  )
}
